// One-image-at-a-time product gallery: arrows step the snap track, dots mirror the visible slide.
class SProductGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-product-gallery]');
    if (!this.track) return;
    this.prev = this.querySelector('[data-gallery-prev]');
    this.next = this.querySelector('[data-gallery-next]');
    this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
    this.prev?.addEventListener('click', () => this.step(-1));
    this.next?.addEventListener('click', () => this.step(1));
    this.onScroll = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    };
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    try {
      this.variantMedia = JSON.parse('{' + (this.querySelector('[data-variant-media]')?.textContent.trim() || '') + '}');
    } catch {
      this.variantMedia = {};
    }
    this.onVariantChange = (event) => {
      const variantId = event.target?.dataset?.variantId;
      if (variantId) this.showMedia(this.variantMedia[variantId]);
    };
    document.addEventListener('change', this.onVariantChange);
    this.update();
  }

  showMedia(mediaId) {
    if (!mediaId) return;
    const slides = [...this.track.children];
    const target = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
    if (target < 0) return;
    this.step(target - this.index);
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('change', this.onVariantChange);
    cancelAnimationFrame(this.frame);
  }

  get index() {
    const width = this.track.clientWidth || 1;
    return Math.round(Math.abs(this.track.scrollLeft) / width);
  }

  get count() {
    return this.track.children.length;
  }

  step(direction) {
    const rtl = getComputedStyle(this.track).direction === 'rtl';
    const target = Math.max(0, Math.min(this.count - 1, this.index + direction));
    const left = target * this.track.clientWidth * (rtl ? -1 : 1);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
  }

  update() {
    const index = this.index;
    if (this.prev) this.prev.disabled = index <= 0;
    if (this.next) this.next.disabled = index >= this.count - 1;
    this.dots.forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
